/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PickDto } from '../../models/pick-dto';

export interface PickControllerToggleBlocked$Params {
  id: string;
}

export function pickControllerToggleBlocked(http: HttpClient, rootUrl: string, params: PickControllerToggleBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
  const rb = new RequestBuilder(rootUrl, pickControllerToggleBlocked.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PickDto>;
    })
  );
}

pickControllerToggleBlocked.PATH = '/api/picks/{id}/toggle-blocked';
